<template>
  <div id="inbox">
    <div class="panel-title">Inbox</div>
    <inboxFilter></inboxFilter>
    <spinner :show="loading"></spinner>
    <retype-dialog v-if="showModal" v-model="showModal" :infobit="selectedInfobit"></retype-dialog>
    <ul v-dragula="infobits" bag="infobits">
      <li class="inbox-item" v-for="infobit in infobits" :key="infobit.id">
        <infobit :infobit="infobit">
          <button title="Copy"              class="fa fa-copy"     @click.stop="copyToClipboard(infobit)"></button>
          <button title="Retype"            class="fa fa-exchange" @click="showRetypeDialog(infobit)"
            :disabled="!loggedInUser"></button>
          <button title="Remove from inbox" class="fa fa-remove"   @click.stop="remove(infobit.id)"
            :disabled="!loggedInUser"></button>
        </infobit>
        <!--span class="debug">{{infobit.id}}</span-->
      </li>
    </ul>
  </div>
</template>

<script>
import PasteAction from '../paste-action'

export default {

  data () {
    return {
      showModal: false,
      selectedInfobit: undefined
    }
  },

  computed: {

    infobits () {
      return this.$store.getters.filteredInboxInfobits
    },

    loading () {
      return this.$store.state.inbox.loading
    },

    loggedInUser () {
      return this.$store.state.user
    }
  },

  methods: {

    showRetypeDialog (infobit) {
      this.selectedInfobit = infobit
      this.showModal = true
    },

    remove (infobitId) {
      this.$store.dispatch('removeInfobitFromInbox', infobitId)
    },

    copyToClipboard (infobit) {
      this.$store.dispatch('copyToClipboard', {content: infobit, action: PasteAction.INSERT})
    }
  },

  components: {
    'infobit':       require('./infobit.vue'),
    'spinner':       require('./spinner.vue'),
    'inboxFilter':   require('./inbox-filter.vue'),
    'retype-dialog': require('./retype-dialog.vue')
  }
}
</script>

<style>
#inbox {
  width: 30%;
  overflow: auto;
  box-sizing: border-box;
  background-color: var(--inbox-panel-color);
  padding-left:  var(--horizontal-panel-padding);
  padding-right: var(--horizontal-panel-padding);
}

#inbox input:focus {
  background-color: rgba(255, 255, 255, 0.7);
}

#inbox ul {
  padding-left: 0;    /* ul browser stylesheet is 40px */
}

#inbox .inbox-filter {
  margin-bottom: 2em;
}

/* Note: rule is independent from DOM structure in order to apply to dragula mirror element as well */
.inbox-item {
  display: flex;
  list-style-type: none;
  margin-top: var(--infobit-list-spacing);
}

.inbox-item .infobit {
  padding-top:    var(--infobit-padding-top);
  padding-bottom: var(--infobit-padding-bottom);
}
</style>



// WEBPACK FOOTER //
// inbox.vue?d1005cce